/*
==============================
Menu Horizontal gris
==============================
*/
$(function() {
    var timer_resize,
        menus = [],
        grayMenu = false;

    function checkAddSwiper() {
        $('.menu-horizontal').each(function(i) {
            var $wrapper = $(this).find('.swiper-wrapper'),
                swiper = false,
                id = $(this).attr('id');

            if ($wrapper.children().last().offset().top != $wrapper.children().first().offset().top) {
                $wrapper.removeClass('block');
                swiper = new Swiper('#' + id + ' .swiper-container', {
                    spaceBetween: 0,
                    slidesPerView: 'auto',
                    freeMode: true,
                    preventClicksPropagation: false,
                    resistanceRatio: 0.3,
                    roundLengths: true,
                    initialSlide: $wrapper.children('.active').index(),
                    onInit : checkBlurSwiper,
                    onSliderMove : checkBlurSwiper,
                    onTransitionEnd : checkBlurSwiper
                });
            }

            menus.push({
                elm: $(this),
                wrapper: $wrapper,
                swiper: swiper,
                id: id,
                activeSwiperSlide: 0
            });

            slideToActiveSwiper(menus[i]);
        });
    }

    function slideToActiveSwiper(menu) {
        if (menu.swiper && typeof menu.swiper !== "undefined") {
            var swiperTarget = menu.wrapper.children('.active'),
                swiperTargetIndex = swiperTarget.index(),
                slideToIndex = 0;

            if (swiperTargetIndex === 0 || swiperTargetIndex == menu.wrapper.children().length-1) {
                menu.swiper.params.centeredSlides = false;
                slideToIndex = menu.wrapper.children('.active').index();
            }
            else if (window.innerWidth > media.mobile) {
                menu.swiper.params.centeredSlides = false;
                slideToIndex = menu.wrapper.children('.active').prev().index();
            }
            else {
                menu.swiper.params.centeredSlides = true;
                slideToIndex = menu.wrapper.children('.active').index();
            }
            menu.swiper.update();
            menu.swiper.slideTo(slideToIndex);
        }
        menu.wrapper.children().css('opacity', 1);
    }

    function checkBlurSwiper(swiper) {
        var $blurLeft = swiper.container.find('.swiper-blur-left'),
            $blurRight = swiper.container.find('.swiper-blur-right');

        if (swiper.isBeginning) {
            $blurLeft.css({
                'opacity': 0,
                'z-index': -1
            });
            $blurRight.css({
                'opacity': 1,
                'z-index': 2
            });
        }
        else if (swiper.isEnd) {
            $blurRight.css({
                'opacity': 0,
                'z-index': -1
            });
            $blurLeft.css({
                'opacity': 1,
                'z-index': 2
            });
        }
        else {
            swiper.container.find('.swiper-blur-left, .swiper-blur-right').css({
                'opacity': 1,
                'z-index': 2
            });
        }
    }

    function swiperSlideClicked(menu) {
        var dataTarget = menu.activeSwiperSlide.attr('data-target');

        if (dataTarget.length > 1) {
           var $dataTargetSiblings = $('#' + menu.id).closest('section').find('.' + $(dataTarget).attr('class').split(' ')[0]);

            $dataTargetSiblings.not(dataTarget).fadeOut(300).promise().done(function() {
                $(dataTarget).fadeIn(300, function() {
                    $dataTargetSiblings.removeClass('active');
                    $(dataTarget).addClass('active');
                    slideToActiveSwiper(menu);
                    setHash(dataTarget);
                    onGlobalResize();

                    var topPos = (window.innerWidth > media.mobile) ? 70 : (menu.elm.hasClass('menu-wallet')) ? -26 : 0;

                    $('html, body').animate({
                        scrollTop: menu.elm.offset().top - topPos
                    }, 300);
                });
            });
        }
        menu.wrapper.children('.swiper-slide').removeClass('active');
        menu.activeSwiperSlide.addClass('active');
        slideToActiveSwiper(menu);
    }

    function checkHashURL(evt) {
        var hash = window.location.hash,
            pathname = window.location.pathname;

        for (var j = 0; j < menus.length; j++) {
            menus[j].wrapper.children('.swiper-slide').each(function(i) {
                if ((hash.length > 1 && (hash.indexOf('ficha-') > 0 || hash.indexOf('menu-') > 0)) && $(this).attr('data-target') == hash) {
                    menus[j].activeSwiperSlide = $(this);
                    swiperSlideClicked(menus[j]);
                    return false;
                }
                else if ($(this).children('a').attr('href') == pathname) {
                    menus[j].activeSwiperSlide = $(this);
                    swiperSlideClicked(menus[j]);
                    return false;
                }
                else if (i == menus[j].wrapper.children('.swiper-slide').length-1 && evt == 'hashchange') {
                    menus[j].activeSwiperSlidee =  menus[j].wrapper.children('.swiper-slide').first();
                    swiperSlideClicked(menus[j]);
                    return false;
                }
            });
        }
    }

    function checkFixedMenu(menu) {
        var $fixedMenu = menu.elm.find('.menu-fixed'),
            $menuHorizontal = menu.elm,
            isInSectionScroll = $menuHorizontal.data('section-only') && ($(document).scrollTop() + $menuHorizontal.height()-45) > ($menuHorizontal.closest('section').offset().top + $menuHorizontal.closest('section').height());

        if ($menuHorizontal.length > 0 && $menuHorizontal.offset().top <= $(document).scrollTop() && !$fixedMenu.hasClass('fixed') && !isInSectionScroll) {
            $fixedMenu.addClass('fixed');
            $fixedMenu.css('top', 0);
            setTimeout(function() {
                slideToActiveSwiper(menu);
            }, 400);
        }
        else if ($menuHorizontal.length > 0 && $menuHorizontal.offset().top > $(document).scrollTop() && $fixedMenu.hasClass('fixed')) {
            $fixedMenu.removeClass('fixed');
            setTimeout(function() {
                slideToActiveSwiper(menu);
            }, 400);
        }
        else if ($menuHorizontal.length > 0 && $fixedMenu.hasClass('fixed') && isInSectionScroll) {
            clearTimeout(timer_resize);
            timer_resize = setTimeout(function() {
                $fixedMenu.css('top', -$fixedMenu.outerHeight());
                setTimeout(function() {
                    $fixedMenu.removeClass('fixed');
                }, 400);
            }, 200);
        }
    }

    function fixMenuHeight(menu) {
        var $fixedMenu = menu.elm.find('.menu-fixed');

        if ($fixedMenu && $fixedMenu.length > 0)
            menu.elm.css('height', $fixedMenu.outerHeight());
            fixHeights.updateHeights();
    }

    if ($('.menu-horizontal').length > 0) {
        $(document).on('click', '.menu-horizontal .swiper-slide', function(e) {
            if ($(this).children('a').attr('href')[0] == "#") {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                var id = $(this).closest('.menu-horizontal').attr('id');

                for (var i = 0; i < menus.length; i++) {
                    if (menus[i].id == id) {
                        menus[i].activeSwiperSlide = $(this);
                        clearTimeout(timer_resize);
                        timer_resize = setTimeout(function() {
                            swiperSlideClicked(menus[i]);
                        }, 50);
                        return false;
                    }
                }
            }
        }).on('click', '.swiper-blur-right', function(e) {
            var id = $(this).closest('.menu-horizontal').attr('id');

            for (var i = 0; i < menus.length; i++) {
                if (menus[i].id == id) {
                    menus[i].swiper.slideNext();
                    return false;
                }
            }
        }).on('click', '.swiper-blur-left', function(e) {
            var id = $(this).closest('.menu-horizontal').attr('id');

            for (var i = 0; i < menus.length; i++) {
                if (menus[i].id == id) {
                    menus[i].swiper.slidePrev();
                    return false;
                }
            }
        });

        $(window).on('resize', function() {
            clearTimeout(timer_resize);
            timer_resize = setTimeout(checkAddSwiper, 100);
        }).on('hashchange', function(e) {
            e.preventDefault();
            checkHashURL('hashchange');
        }).on('scroll', function() {
            for (var i = 0; i < menus.length; i++) {
                checkFixedMenu(menus[i]);
            }
        });

        checkAddSwiper();
        checkHashURL('ready');

        for (var i = 0; i < menus.length; i++) {
            fixMenuHeight(menus[i]);
            checkFixedMenu(menus[i]);
            fixMenuHeight(menus[i]);

            if (!menus[i].elm.hasClass('menu-wallet')) grayMenu = true;
            else if (grayMenu) menus[i].elm.find('.menu-horizontal-gris').addClass('small-arrows');
        }
    }
});